import { CSSProperties, ReactNode } from 'react';
import { OhatStatus } from '../../../constants/status';
import { RESULT_COLORS } from '../../../constants/result-colors';

// getScoreTableRow は比較用に日本語ラベルを返すため、表示だけ言語に合わせて変換する。
const toDisplayLabel = (jaLabel: string, lang?: string) => {
  const status = OhatStatus.getAll().find((s) => s.label === jaLabel);
  return status ? status.getLabel(lang) : jaLabel;
};

/** ステータス（日本語ラベル）に対応するセル背景色。未回答は健康的と同じ扱い。 */
const getCellBackground = (jaLabel: string): string => {
  if (jaLabel === OhatStatus.bad.label) return RESULT_COLORS.cellBad;
  if (jaLabel === OhatStatus.diseased.label) return RESULT_COLORS.cellDiseased;
  return RESULT_COLORS.cellFine;
};

/** ステータスに対応するスコア（pt）。未回答は 0pt 扱い。 */
const getCellScore = (jaLabel: string): number => {
  if (jaLabel === OhatStatus.bad.label) return OhatStatus.bad.score;
  if (jaLabel === OhatStatus.diseased.label) return OhatStatus.diseased.score;
  return OhatStatus.fine.score;
};

/**
 * ステータスセルの表示（ラベル + スコア）。
 * 印刷時に文字がつぶれないよう、太字にせず大きめの文字で表示する。
 * 英語の「Unhealthy」等は1語で列幅を超えるため、単語の途中でも折り返せるようにして
 * セル（ひいては表全体）が親幅からはみ出さないようにする。
 */
export const renderStatusCell =
  (lang?: string) =>
  (text: string): ReactNode => (
    <span
      style={{
        color: RESULT_COLORS.cellText,
        fontWeight: 400,
        fontSize: '14px',
        overflowWrap: 'anywhere',
      }}
    >
      {toDisplayLabel(text, lang)}
      <br />
      {`${getCellScore(text)}pt`}
    </span>
  );

/**
 * ステータスセルの背景色をセル全体に敷くための onCell。
 * dataIndex は列の dataIndex（レコードのキー）。
 */
export const statusCellProps =
  (dataIndex: number) =>
  (record: any): { style: CSSProperties } => ({
    style: { backgroundColor: getCellBackground(record?.[dataIndex]) },
  });
